import api from "./api";
import endpoints from "./endpoints";

export default {
  get(languages, type) {
    return api
      .get(endpoints.attributeManager.catalogAttributes.get, {
        params: { languages, catalogType: type }
      })
      .then((x) => Promise.resolve(x.data));
  },
  update(model) {
    return api.post(endpoints.attributeManager.catalogAttributes.update, model).then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.catalogAttributes.delete, items).then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api
      .post(endpoints.attributeManager.catalogAttributes.deepL, model, { params: { sourceLanguage: sourceLanguage } })
      .then((x) => Promise.resolve(x.data));
  }
};
